import { CommonModule } from '@angular/common';
import { Component, Input, type OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { createSafeResourceUrl, validateResourceUrl } from 'src/app/shared/utils/safe-resource-url.util';
import { environment } from 'src/environments/environment';

const FILE_ALLOWED_DOMAINS = ['amazonaws.com'];
const FILE_ALLOWED_ORIGINS = [new URL(environment.apiGestorUrlLocal).origin];

@Component({
  selector: 'app-visualizador-arquivos',
  templateUrl: './visualizador-arquivos.component.html',
  styleUrls: ['./visualizador-arquivos.component.scss'],
})
export class VisualizadorArquivosComponent implements OnInit {
  @Input() fileUrl!: string;
  @Input() fileName?: string;
  @Input() mimeType?: string;
  @Input() visualizar_enviar!: boolean;
  fileType!: 'image' | 'audio' | 'pdf' | 'video' | null;
  sanitizedUrl!: SafeResourceUrl | string | null;

  constructor(
    private sanitizer: DomSanitizer,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    if (this.visualizar_enviar) {
      this.fileType = 'image';
      this.sanitizedUrl = this.sanitizer.sanitize(SecurityContext.URL, this.fileUrl);
    } else {
      this.determineFileType();
      if (this.fileType === 'pdf') {
        this.sanitizedUrl = createSafeResourceUrl(this.sanitizer, this.fileUrl, {
          allowedDomains: FILE_ALLOWED_DOMAINS,
          allowedOrigins: FILE_ALLOWED_ORIGINS,
          allowBlob: true
        });
      } else {
        this.sanitizedUrl = this.sanitizer.sanitize(SecurityContext.URL, this.fileUrl);
      }
    }
  }

  private determineFileType(): void {
    const ext = this.obterExtensaoArquivo(this.fileName, this.mimeType, this.fileUrl);

    if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'].includes(ext)) {
      this.fileType = 'image';
    } else if (['mp3', 'wav', 'ogg'].includes(ext)) {
      this.fileType = 'audio';
    } else if (['mp4', 'webm', 'mov'].includes(ext)) {
      this.fileType = 'video';
    } else if (ext === 'pdf') {
      this.fileType = 'pdf';
    } else {
      this.fileType = null;
    }
  }

  private obterExtensaoArquivo(...valores: Array<string | undefined>): string {
    for (const valor of valores) {
      const arquivo = (valor || '').split('?')[0].toLowerCase();

      if (!arquivo) {
        continue;
      }

      if (arquivo.includes('/')) {
        const mime = arquivo.split('/').pop() || '';
        if (mime && !mime.includes('.')) {
          return this.normalizarExtensaoArquivo(mime);
        }
      }

      if (arquivo.includes('.')) {
        return this.normalizarExtensaoArquivo(arquivo.split('.').pop() || '');
      }

      return this.normalizarExtensaoArquivo(arquivo);
    }

    return '';
  }

  private normalizarExtensaoArquivo(extensao: string): string {
    const ext = (extensao || '').toLowerCase();

    if (ext === 'svg+xml') {
      return 'svg';
    }

    if (ext === 'mpeg') {
      return 'mp3';
    }

    if (ext === 'quicktime') {
      return 'mov';
    }

    return ext;
  }

  close(result?) {
    this.activeModal.close(result);
  }

  abrirNovaGuia(): void {
    const validatedUrl = validateResourceUrl(this.fileUrl, {
      allowedDomains: FILE_ALLOWED_DOMAINS,
      allowedOrigins: FILE_ALLOWED_ORIGINS,
      allowBlob: true
    });

    if (!validatedUrl) {
      return;
    }

    const openedWindow = window.open(validatedUrl, '_blank', 'noopener,noreferrer');
    if (openedWindow) {
      openedWindow.opener = null;
    }
  }
}
